/*
 * @bot-written
 *
 * WARNING AND NOTICE
 * Any access, download, storage, and/or use of this source code is subject to the terms and conditions of the
 * Full Software Licence as accepted by you before being granted access to this source code and other materials,
 * the terms of which can be accessed on the Codebots website at https://codebots.com/full-software-licence. Any
 * commercial use in contravention of the terms of the Full Software Licence may be pursued by Codebots through
 * licence termination and further legal action, and be required to indemnify Codebots for any loss or damage,
 * including interest and costs. You are deemed to have accepted the terms of the Full Software Licence on any
 * access, download, storage, and/or use of this source code.
 *
 * BOT WARNING
 * This file is bot-written.
 * Any changes out side of "protected regions" will be lost next time the bot makes any changes.
 */
import {
	Model,
	IModelAttributes,
	attribute,
	entity,
} from 'Models/Model';
import * as Models from 'Models/Entities';
import { IAcl } from '../Security/IAcl';
import { observable } from 'mobx';
import ApplicationUserPlaylistsReferenceManyToMany from '../Security/Acl/ApplicationUserPlaylistsReferenceManyToMany';
import AgencyPlaylisterPlaylistsReferenceManyToMany from '../Security/Acl/AgencyPlaylisterPlaylistsReferenceManyToMany';
import AgencyAdminPlaylistsReferenceManyToMany from '../Security/Acl/AgencyAdminPlaylistsReferenceManyToMany';
import VisitorsPlaylistsReferenceManyToMany from '../Security/Acl/VisitorsPlaylistsReferenceManyToMany';
import MustardAdminPlaylistsReferenceManyToMany from '../Security/Acl/MustardAdminPlaylistsReferenceManyToMany';
import MustardManagementPlaylistsReferenceManyToMany from '../Security/Acl/MustardManagementPlaylistsReferenceManyToMany';
// % protected region % [Add any further imports here] off begin
// % protected region % [Add any further imports here] end

export interface IAgencyTagsPlaylistsAttributes extends IModelAttributes {
	agencyTagsId: string;
	playlistsId: string;

	agencyTags: Models.AgencyTagEntity | Models.IAgencyTagEntityAttributes;
	playlists: Models.PlaylistEntity | Models.IPlaylistEntityAttributes;
	// % protected region % [Add any custom attributes to the interface here] off begin
	// % protected region % [Add any custom attributes to the interface here] end
}

@entity('AgencyTagsPlaylists')
export default class AgencyTagsPlaylists
	extends Model
	implements IAgencyTagsPlaylistsAttributes {
	public static acls: IAcl[] = [
		new ApplicationUserPlaylistsReferenceManyToMany(),
		new AgencyPlaylisterPlaylistsReferenceManyToMany(),
		new AgencyAdminPlaylistsReferenceManyToMany(),
		new VisitorsPlaylistsReferenceManyToMany(),
		new MustardAdminPlaylistsReferenceManyToMany(),
		new MustardManagementPlaylistsReferenceManyToMany(),
		// % protected region % [Add any further ACL entries here] off begin
		// % protected region % [Add any further ACL entries here] end
	];

	@observable
	@attribute()
	public agencyTagsId: string;

	@observable
	@attribute()
	public playlistsId: string;

	@observable
	@attribute({ isReference: true })
	public agencyTags: Models.AgencyTagEntity;

	@observable
	@attribute({ isReference: true })
	public playlists: Models.PlaylistEntity;
	// % protected region % [Add any custom attributes to the model here] off begin
	// % protected region % [Add any custom attributes to the model here] end

	constructor(attributes?: Partial<IAgencyTagsPlaylistsAttributes>) {
		// % protected region % [Add any extra constructor logic before calling super here] off begin
		// % protected region % [Add any extra constructor logic before calling super here] end

		super(attributes);

		if (attributes) {
			if (attributes.agencyTagsId) {
				this.agencyTagsId = attributes.agencyTagsId;
			}
			if (attributes.playlistsId) {
				this.playlistsId = attributes.playlistsId;
			}

			if (attributes.agencyTags) {
				if (attributes.agencyTags instanceof Models.AgencyTagEntity) {
					this.agencyTags = attributes.agencyTags;
					this.agencyTagsId = attributes.agencyTags.id;
				} else {
					this.agencyTags = new Models.AgencyTagEntity(attributes.agencyTags);
					this.agencyTagsId = this.agencyTags.id;
				}
			} else if (attributes.agencyTagsId !== undefined) {
				this.agencyTagsId = attributes.agencyTagsId;
			}

			if (attributes.playlists) {
				if (attributes.playlists instanceof Models.PlaylistEntity) {
					this.playlists = attributes.playlists;
					this.playlistsId = attributes.playlists.id;
				} else {
					this.playlists = new Models.PlaylistEntity(attributes.playlists);
					this.playlistsId = this.playlists.id;
				}
			} else if (attributes.playlistsId !== undefined) {
				this.playlistsId = attributes.playlistsId;
			}
		}

		// % protected region % [Add any extra constructor logic after calling super here] off begin
		// % protected region % [Add any extra constructor logic after calling super here] end
	}

	// % protected region % [Add any further custom model features here] off begin
	// % protected region % [Add any further custom model features here] end
}
